if (typeof window.quickShopManager === 'undefined') {
    class QuickShopManager {
        constructor() {
            this.cartCache = new Map();
            this.isAddingToCart = false;
            this.isOpeningCart = false;
            this.init();
        }

        init() {
            this.setupGlobalPatches();
            this.bindEvents();
            this.protectHeader();
        }

        setupGlobalPatches() {
            try {
                const globalScript = window.getFocusableElements || window.Shopify?.theme?.getFocusableElements;

                if (typeof globalScript === 'function') {
                    window.getFocusableElements = function (container) {
                        if (!container) {
                            return [];
                        }
                        return container.querySelectorAll('a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
                    };
                }
            } catch (e) {
            }
        }

        bindEvents() {
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', () => this.initializeQuickShop());
            } else {
                this.initializeQuickShop();
            }
            
            document.addEventListener('shopify:section:load', () => {
                setTimeout(() => this.initializeQuickShop(), 100);
            });
            document.addEventListener('shopify:theme:load', () => {
                setTimeout(() => this.initializeQuickShop(), 100);
            });
            
            document.addEventListener('slider:loaded', () => {
                setTimeout(() => this.initializeQuickShop(), 200);
            });
            
            let resizeTimer;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(() => {
                    this.syncWrapperHeights();
                }, 250);
            });
            
            document.addEventListener('load', (e) => {
                if (e.target.tagName === 'IMG') {
                    setTimeout(() => this.syncWrapperHeights(), 100);
                }
            }, true);
            
            setInterval(() => {
                this.initializeQuickShop();
            }, 2000);
        }

        protectHeader() {
            try {
                const headerElements = [
                    '.section-header',
                    '.header-wrapper',
                    '.header',
                    '.shopify-section-group-header-group'
                ];

                headerElements.forEach(selector => {
                    const element = document.querySelector(selector);
                    if (element) {
                        element.style.display = '';
                        element.style.visibility = '';
                        element.classList.remove('hidden');
                        
                        if (element.style.display === 'none') {
                            element.style.display = '';
                        }
                        if (element.style.visibility === 'hidden') {
                            element.style.visibility = '';
                        }
                    }
                });

                const body = document.body;
                if (body) {
                    const classesToRemove = ['header-hidden', 'hide-header'];
                    classesToRemove.forEach(className => {
                        if (body.classList.contains(className)) {
                            body.classList.remove(className);
                        }
                    });
                }
            } catch (e) {
            }
        }

        closeOtherCards(currentCard) {
            const cards = document.querySelectorAll('.card__actions--addtobag');
            cards.forEach(card => {
                if (card !== currentCard) {
                    const button = card.querySelector('.card__actions-button');
                    const variants = card.querySelector('.card__variants');
                    if (button && variants) {
                        button.classList.remove('hidden');
                        variants.classList.add('hidden');
                    }
                }
            });
        }

        waitForCartToRender(maxAttempts = 15) {
            return new Promise((resolve, reject) => {
                let attempts = 0;

                const check = () => {
                    attempts++;
                    const cartDrawer = document.querySelector('cart-drawer');

                    if (
                        cartDrawer &&
                        cartDrawer.querySelector('.cart-items') &&
                        cartDrawer.querySelector('.cart-items').children.length > 0
                    ) {
                        resolve();
                    } else if (attempts >= maxAttempts) {
                        reject('Cart drawer não renderizou a tempo');
                    } else {
                        setTimeout(check, 300);
                    }
                };

                check();
            });
        }

        waitForCartDrawer(maxAttempts = 15) {
            return new Promise((resolve, reject) => {
                let attempts = 0;

                const checkCartDrawer = () => {
                    attempts++;
                    const cartDrawer = document.querySelector('cart-drawer');

                    if (
                        cartDrawer &&
                        typeof cartDrawer.open === 'function' &&
                        cartDrawer.isConnected &&
                        cartDrawer.offsetHeight >= 0
                    ) {
                        resolve(cartDrawer);
                    } else if (attempts >= maxAttempts) {
                        reject(new Error('Cart drawer não encontrado'));
                    } else {
                        setTimeout(checkCartDrawer, 400);
                    }
                };

                checkCartDrawer();
            });
        }

        async forceCartUpdate() {
            try {
                const response = await fetch(`${window.routes?.cart_url || '/cart'}?section_id=cart-drawer`);
                if (response.ok) {
                    const html = await response.text();
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');

                    const newCartDrawer = doc.querySelector('#CartDrawer');
                    const currentCartDrawer = document.querySelector('#CartDrawer');
                    if (newCartDrawer && currentCartDrawer) {
                        currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
                        const host = document.querySelector('cart-drawer');
                        const itemsRoot = host?.querySelector('cart-drawer-items');
                        if (host && itemsRoot) {
                            const hasLineItems = !!itemsRoot.querySelector('.cart-item');
                            host.classList.toggle('is-empty', !hasLineItems);
                            itemsRoot.classList.toggle('is-empty', !hasLineItems);
                        }
                    }

                    const cartIconResponse = await fetch(`${window.routes?.cart_url || '/cart'}?section_id=cart-icon-bubble`);
                    if (cartIconResponse.ok) {
                        const cartIconHtml = await cartIconResponse.text();
                        const cartIconDoc = parser.parseFromString(cartIconHtml, 'text/html');
                        const newCartIcon = cartIconDoc.querySelector('#cart-icon-bubble');
                        const currentCartIcon = document.querySelector('#cart-icon-bubble');
                        if (newCartIcon && currentCartIcon) {
                            currentCartIcon.innerHTML = newCartIcon.innerHTML;
                        }
                    }
                }
            } catch (e) {
            }
        }

        async openCartDrawer() {
            if (this.isOpeningCart) {
                return;
            }

            try {
                this.isOpeningCart = true;
                const cartDrawer = await this.waitForCartDrawer();

                await this.waitForCartToRender();
                cartDrawer.open();
            } catch (error) {
                try {
                    const fallback = document.querySelector('#cart-icon-bubble, .cart-icon, [data-cart-toggle]');
                    if (fallback) fallback.click();
                } catch (fallbackError) {
                }
            } finally {
                this.isOpeningCart = false;
            }
        }

        async handleSingleVariantForm(form, button) {
            if (this.isAddingToCart) {
                return;
            }

            try {
                const variantIdInput = form.querySelector('.product-variant-id');
                const variantId = variantIdInput ? variantIdInput.value : null;

                if (!variantId) {
                    throw new Error('Variant ID não encontrado');
                }

                await this.addToCart(variantId, button);

            } catch (err) {
                this.setButtonLoading(button, false);
            }
        }

        setButtonLoading(button, isLoading) {
            if (!button) return;

            const variants = button.closest('.card__variants');
            const card = button.closest('.card__actions--addtobag');

            if (isLoading) {
                if (!button.dataset.loadingOriginal) {
                    button.dataset.loadingOriginal = button.innerHTML;
                }

                button.classList.add('card__variant-item--loading', 'card__actions-button--loading');
                button.setAttribute('aria-busy', 'true');
                button.disabled = true;
                button.innerHTML = '<span class="card__variant-spinner" aria-hidden="true"></span>';

                if (variants) {
                    variants.classList.add('card__variants--loading');
                }

                if (card) {
                    card.querySelectorAll('.card__variant-item--available').forEach((item) => {
                        if (item !== button) {
                            item.disabled = true;
                        }
                    });
                }
            } else {
                button.classList.remove('card__variant-item--loading', 'card__actions-button--loading');
                button.removeAttribute('aria-busy');
                button.disabled = false;

                if (button.dataset.loadingOriginal) {
                    button.innerHTML = button.dataset.loadingOriginal;
                    delete button.dataset.loadingOriginal;
                }

                if (variants) {
                    variants.classList.remove('card__variants--loading');
                }

                if (card) {
                    card.querySelectorAll('.card__variant-item--available').forEach((item) => {
                        item.disabled = false;
                    });
                }
            }
        }

        async addToCart(variantId, button) {
            if (this.isAddingToCart) {
                return;
            }

            try {
                this.isAddingToCart = true;
                this.setButtonLoading(button, true);

                this.protectHeader();

                const id = parseInt(variantId);
                if (!id || isNaN(id)) throw new Error(`ID inválido: ${variantId}`);

                let cartWasEmpty = false;
                try {
                    const cartRes = await fetch('/cart.js');
                    const cartJson = await cartRes.json();
                    cartWasEmpty = cartJson.item_count === 0;
                } catch (e) {
                }

                const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

                const config = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id, quantity: 1 })
                };

                if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
                    try {
                        const sections = cartDrawer.getSectionsToRender();
                        if (sections && sections.length > 0) {
                            const formData = new FormData();
                            formData.append('id', id);
                            formData.append('quantity', 1);
                            formData.append('sections', sections.map(s => s.id));
                            formData.append('sections_url', window.location.pathname);
                            config.body = formData;
                            config.headers = {};
                        }
                    } catch (err) {
                    }
                }

                const response = await fetch('/cart/add.js', config);
                if (!response.ok) throw new Error(`Erro HTTP ${response.status}`);

                const data = await response.json();
                this.cartCache.set('lastUpdate', Date.now());

                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: 'quick-shop',
                        productVariantId: String(id),
                        cartData: data,
                    });
                }

                if (cartDrawer) {
                    if (cartWasEmpty) {
                        await this.forceCartUpdate();

                        if (cartDrawer.classList.contains('is-empty')) {
                            cartDrawer.classList.remove('is-empty');
                        }

                        const drawerInner = cartDrawer.querySelector('.drawer__inner');
                        if (drawerInner && drawerInner.classList.contains('is-empty')) {
                            drawerInner.classList.remove('is-empty');
                        }

                        const cartDrawerItems = cartDrawer.querySelector('cart-drawer-items');
                        if (cartDrawerItems && cartDrawerItems.classList.contains('is-empty')) {
                            cartDrawerItems.classList.remove('is-empty');
                        }
                    }

                    if (typeof cartDrawer.renderContents === 'function') {
                        await cartDrawer.renderContents(data);
                    } else if (typeof cartDrawer.refresh === 'function') {
                        await cartDrawer.refresh();
                    }

                    await this.waitForCartToRender();
                    requestAnimationFrame(() => {
                        cartDrawer.open();
                    });
                }

                await this.openCartDrawer();

                const cartIcon = document.querySelector('#cart-icon-bubble');
                if (cartIcon) {
                    try {
                        const cartResponse = await fetch('/cart.js');
                        const cartData = await cartResponse.json();
                        const cartCount = cartIcon.querySelector('.cart-count-bubble');
                        if (cartCount) {
                            cartCount.textContent = cartData.item_count;
                            if (cartData.item_count > 0) {
                                cartCount.style.display = 'flex';
                            }
                        }
                    } catch (e) {
                    }
                }

                this.protectHeader();

            } catch (err) {
            } finally {
                this.setButtonLoading(button, false);
                this.isAddingToCart = false;
                this.protectHeader();
            }
        }

        initializeQuickShop() {
            try {
                const cards = document.querySelectorAll('.card__actions--addtobag');

                if (cards.length === 0) {
                    setTimeout(() => {
                        const retryCards = document.querySelectorAll('.card__actions--addtobag');
                        if (retryCards.length > 0) {
                            this.initCards(retryCards);
                        }
                    }, 1000);
                    return;
                }

                this.initCards(cards);
                this.syncWrapperHeights();
                
                setTimeout(() => {
                    const allVariantsLists = document.querySelectorAll('.card__variants-list');
                    allVariantsLists.forEach(list => {
                        this.sortQuickShopSizes(list);
                    });
                }, 100);
            } catch (e) {
            }
        }

        syncWrapperHeights() {
            try {
                const wrappers = document.querySelectorAll('.card__actions--addtobag-wrapper');
                
                wrappers.forEach(wrapper => {
                    const card = wrapper.closest('.card-wrapper, .product-card-wrapper');
                    if (!card) return;

                    const cardMedia = card.querySelector('.card__media');
                    if (!cardMedia) return;

                    const mediaHeight = cardMedia.offsetHeight;
                    
                    if (mediaHeight > 0) {
                        wrapper.style.height = `${mediaHeight}px`;
                    }
                });
            } catch (e) {
            }
        }

        getSizeNumber(text) {
            if (!text) return 999;
            const str = String(text).trim();
            let match = str.match(/\b(\d{2})\b/);
            if (!match) {
                match = str.match(/\b(\d{1,2})\b/);
            }
            if (!match) {
                match = str.match(/(\d+)/);
            }
            if (match) {
                const num = parseInt(match[1], 10);
                if (num >= 0 && num <= 100) {
                    return num;
                }
            }
            return 999;
        }

        sortQuickShopSizes(variantsContainer) {
            if (!variantsContainer) return;
            
            const variantButtons = Array.from(variantsContainer.querySelectorAll('.card__variant-item'));
            if (variantButtons.length === 0) return;

            const elementsToSort = variantButtons.map(button => {
                const sizeSpan = button.querySelector('.card__variant-size');
                const text = sizeSpan ? (sizeSpan.textContent || sizeSpan.innerText || '').trim() : '';
                return {
                    element: button,
                    size: this.getSizeNumber(text),
                    text: text,
                    originalIndex: variantButtons.indexOf(button)
                };
            });

            elementsToSort.sort((a, b) => {
                if (a.size !== 999 && b.size !== 999) {
                    return a.size - b.size;
                }
                if (a.size !== 999 && b.size === 999) return -1;
                if (a.size === 999 && b.size !== 999) return 1;
                return a.originalIndex - b.originalIndex;
            });

            variantButtons.forEach(button => {
                if (button.parentElement) {
                    button.parentElement.removeChild(button);
                }
            });

            elementsToSort.forEach(item => {
                variantsContainer.appendChild(item.element);
            });
        }

        initCards(cards) {
            cards.forEach((card, index) => {
                try {
                    const button = card.querySelector('.card__actions-button');
                    const variants = card.querySelector('.card__variants');

                    if (!button) {
                        return;
                    }

                    if (variants) {
                        const variantsList = variants.querySelector('.card__variants-list');
                        if (variantsList) {
                            this.sortQuickShopSizes(variantsList);
                        }
                    }

                    if (button._quickShopHandler) {
                        button.removeEventListener('click', button._quickShopHandler);
                    }

                    button._quickShopHandler = (e) => {
                        if (button.classList.contains('card__single-add-button')) {
                            e.preventDefault();
                            const form = button.closest('.card__single-add-form');
                            if (form) {
                                this.handleSingleVariantForm(form, button);
                            }
                        } else if (variants) {
                            this.closeOtherCards(card);
                            button.classList.add('hidden');
                            variants.classList.remove('hidden');
                            
                            const variantsList = variants.querySelector('.card__variants-list');
                            if (variantsList) {
                                setTimeout(() => this.sortQuickShopSizes(variantsList), 50);
                            }
                        }
                    };
                    button.addEventListener('click', button._quickShopHandler);

                    if (variants) {
                        if (variants._quickShopHandler) {
                            variants.removeEventListener('click', variants._quickShopHandler);
                        }

                        variants._quickShopHandler = (e) => {
                            if (e.target === variants) {
                                variants.classList.add('hidden');
                                button.classList.remove('hidden');
                            }
                        };
                        variants.addEventListener('click', variants._quickShopHandler);
                    }

                    if (variants) {
                        const variantButtons = variants.querySelectorAll('.card__variant-item--available');

                        variantButtons.forEach((variantButton, variantIndex) => {
                            if (variantButton._quickShopHandler) {
                                variantButton.removeEventListener('click', variantButton._quickShopHandler);
                            }

                            variantButton._quickShopHandler = (e) => {
                                e.stopPropagation();
                                const variantId = variantButton.dataset.variantId;
                                if (variantId) this.addToCart(variantId, variantButton);
                            };
                            variantButton.addEventListener('click', variantButton._quickShopHandler);
                        });
                    }

                } catch (error) {
                }
            });
        }
    }

    window.quickShopManager = new QuickShopManager();
}
